// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listst-search {
  display: flex;
  flex-direction: column;
}

.listst-search{
.search {
  display: flex;
  height: 25px;
}

.search.replace-active {
  height: 55px;
}

.search-btn {
  margin: auto;
  margin-right: 2px;
}

.search-btn button {
  height: 26px;
}

.search-btn button.replace-active {
  height: 54px;
}

.search-form,
.replace-form {
  display: flex;
}

.search-result {
  margin-top: 5px;
  font-size: 14px;
  color:white;
}

.listst-search .tooltip-wrapper {
  margin: auto 2px !important;
}

.replace-form {
  margin-top: 2px;
}

input {
  height: 20px;
  margin-right: 5px;
}

p {
  margin: 0;
}

button img {
  vertical-align: sub;
}

button svg {
  height: 16px;
}

.search-no-result{
  color: #ff9c9c;
}

.sr-only {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
}
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/submenudialogs/searchandreplace/searchandreplace.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;AACA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EAEzC,gCAAgC;EAChC,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;AAChC;AACA","sourcesContent":[".listst-search {\n  display: flex;\n  flex-direction: column;\n}\n\n.listst-search{\n.search {\n  display: flex;\n  height: 25px;\n}\n\n.search.replace-active {\n  height: 55px;\n}\n\n.search-btn {\n  margin: auto;\n  margin-right: 2px;\n}\n\n.search-btn button {\n  height: 26px;\n}\n\n.search-btn button.replace-active {\n  height: 54px;\n}\n\n.search-form,\n.replace-form {\n  display: flex;\n}\n\n.search-result {\n  margin-top: 5px;\n  font-size: 14px;\n  color:white;\n}\n\n.listst-search .tooltip-wrapper {\n  margin: auto 2px !important;\n}\n\n.replace-form {\n  margin-top: 2px;\n}\n\ninput {\n  height: 20px;\n  margin-right: 5px;\n}\n\np {\n  margin: 0;\n}\n\nbutton img {\n  vertical-align: sub;\n}\n\nbutton svg {\n  height: 16px;\n}\n\n.search-no-result{\n  color: #ff9c9c;\n}\n\n.sr-only {\n  border: 0 !important;\n  clip: rect(1px, 1px, 1px, 1px) !important;\n  -webkit-clip-path: inset(50%) !important;\n  clip-path: inset(50%) !important;\n  height: 1px !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  width: 1px !important;\n  white-space: nowrap !important;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
